import MDatePicker from './src';
import './style';

MDatePicker.install = Vue => {
  Vue.component('MDatePicker', MDatePicker);
};

export default MDatePicker;
